const articleClickedEvent = {
    category: "Article",
    action: "Article Clicked",
    label: "",
  };
  
  export { articleClickedEvent };
  